import React, { useState } from "react";
import { Table } from "antd";
import { DatatableProps } from "../../data/interface";
import { RiArrowLeftWideLine, RiArrowRightWideLine } from "react-icons/ri";

const Datatable = ({
  columns,
  dataSource,
  pagination,
  onSelectionChange,
  onPaginationChange,
  loading,
}) => {
  const [selectedRowKeys, setSelectedRowKeys] = useState([]);
  // const [paginationConfig, setPaginationConfig] = useState({
  //   current: 1,
  //   pageSize: 10,
  //   showQuickJumper: true,
  //   total: dataSource.length,
  //   showTotal: (total: number, range: [number, number]) =>
  //     `Showing ${range[0]}–${range[1]} of ${total} results`,
  //   showSizeChanger: true,
  //   pageSizeOptions: ["10", "20", "30"],
  //   onChange: (page: number, pageSize: number) => {
  //     setPaginationConfig({
  //       ...paginationConfig,
  //       current: page,
  //       pageSize: pageSize,
  //     });
  //   },
  //   itemRender: (page: any, type: any, originalElement: any) => {
  //     if (type === "prev") {
  //       return <RiArrowLeftWideLine />;
  //     }
  //     if (type === "next") {
  //       return <RiArrowRightWideLine />;
  //     }
  //     return originalElement;
  //   },
  // });
  const defaultPagination = {
    ...pagination,
    current: pagination?.current || 1,
    pageSize: pagination?.pageSize || 10,
    total: pagination?.total || 0,
    showQuickJumper: pagination?.showQuickJumper ?? true,
    showSizeChanger: pagination?.showSizeChanger ?? true,
    pageSizeOptions: pagination?.pageSizeOptions || ["10", "20", "30"],
    showTotal: pagination?.showTotal,

    // 🔥 NEW: notify parent to call API
    onChange: (page, pageSize) => {
      if (onPaginationChange) {
        onPaginationChange(page, pageSize);
      }
    },

    itemRender: (_, type, originalElement) => {
      if (type === "prev") return <RiArrowLeftWideLine />;
      if (type === "next") return <RiArrowRightWideLine />;
      return originalElement;
    },
  };

  const onSelectChange = (newSelectedRowKeys, selectedRows) => {
    setSelectedRowKeys(newSelectedRowKeys);
    if (onSelectionChange) {
      onSelectionChange(newSelectedRowKeys, selectedRows);
    }
  };

  const rowSelection = {
    selectedRowKeys,
    onChange: onSelectChange,
  };

  // const finalPagination =
  //   pagination !== undefined ? pagination : paginationConfig;

  return (
    <>
      <Table
        className="table datanew dataTable no-footer"
        rowSelection={rowSelection}
        columns={columns}
        dataSource={dataSource}
        loading={loading}
        bordered
        scroll={{
          //  x: 'max-content', y: 300,
          scrollToFirstRowOnChange: true,
        }}
        pagination={defaultPagination}
      />
    </>
  );
};

export default Datatable;
